import type React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Link } from '@xing-com/link';
import { List, ListItem } from '@xing-com/list';
import { xdlColorText } from '@xing-com/tokens';

import { OTHERS_ITEM } from './directories-list';

interface NavigationProps {
  items: string[];
  url: string;
}

const ListContainer = styled(List)`
  display: flex;
  flex-wrap: wrap;

  @media (min-width: 1113px) {
    justify-content: space-between;
  }
`;

const StyledLink = styled(Link)`
  color: ${xdlColorText};
  font-weight: bold;
  text-transform: uppercase;
`;

export const Navigation: React.FC<NavigationProps> = ({ items, url }) => {
  return (
    <nav>
      <ListContainer>
        {items.map((item) => (
          <ListItem key={item}>
            <StyledLink to={`${url}/${item}`}>
              {item === OTHERS_ITEM ? (
                <FormattedMessage id="COMPANY_DIRECTORY_OTHERS" />
              ) : (
                item
              )}
            </StyledLink>
          </ListItem>
        ))}
      </ListContainer>
    </nav>
  );
};
